// frontend/src/pages/Auth/Register.js

import React, { useState, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const Register = () => {
  const { user, register } = useContext(AuthContext);
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  if (user) {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('Die Passwörter stimmen nicht überein.');
      return;
    }
    const result = await register(username, email, password);
    if (!result.success) {
      setError(result.message);
    } else {
      setSuccess(true);
      setError('');
    }
  };

  return (
    <motion.div
      className="max-w-md mx-auto bg-white p-8 rounded shadow mt-10"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      <h2 className="text-2xl font-heading text-center text-primary mb-6">
        Registrierung für Entecity.ch
      </h2>
      {error && (
        <div className="bg-red-100 text-red-700 p-3 rounded mb-4">
          {error}
        </div>
      )}
      {success && (
        <div className="bg-green-100 text-green-700 p-3 rounded mb-4">
          Registrierung erfolgreich! Bitte überprüfen Sie Ihre E-Mail,
          um Ihr Konto zu verifizieren.
        </div>
      )}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-text font-body mb-1">Benutzername</label>
          <input
            type="text"
            className="w-full px-4 py-2 border border-accent rounded focus:outline-none"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            aria-label="Benutzername"
          />
        </div>
        <div>
          <label className="block text-text font-body mb-1">E-Mail</label>
          <input
            type="email"
            className="w-full px-4 py-2 border border-accent rounded focus:outline-none"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            aria-label="E-Mail-Adresse"
          />
        </div>
        <div>
          <label className="block text-text font-body mb-1">Passwort</label>
          <input
            type="password"
            className="w-full px-4 py-2 border border-accent rounded focus:outline-none"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            aria-label="Passwort"
          />
        </div>
        <div>
          <label className="block text-text font-body mb-1">Passwort bestätigen</label>
          <input
            type="password"
            className="w-full px-4 py-2 border border-accent rounded focus:outline-none"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            aria-label="Passwort bestätigen"
          />
        </div>
        <button
          type="submit"
          className="w-full bg-primary text-white px-4 py-2 rounded hover:bg-orange-600 transition"
        >
          Registrieren
        </button>
      </form>
    </motion.div>
  );
};

export default Register;
